module.exports = __webpack_public_path__ + "img/recycle_grey.a6e30bc9.svg";